export enum 商品区分型 {
  医薬品 = '医薬品',
  その他品 = 'その他品',
  備蓄品 = '備蓄品',
  指定なし = '指定なし',
}

export enum マスタ選択区分型 {
  医薬品 = '医薬品',
  その他品 = 'その他品',
  備蓄品 = '備蓄品',
  採用品 = '採用品',
  指定なし = '指定なし',
}

export enum 発注単位区分型 {
  箱 = '箱',
  バラ = 'バラ',
}

export enum 発注有効区分値 {
  有効 = '有効',
  無効 = '無効',
}
